<template>
    <div class="shipping-container">
        <div class="shipping-costs-preview">
            <button class="button" @click="setExpanding()" :class="{ active: isActive }">{{ localizer.get("Cart.Common.CalculateShippingCosts") }}<span class="icon fastic-angle-right fl-r"></span></button>
            <div class="preview form" :class="{ hden: !isActive }">
                <select class="dropdown" v-model.lazy="shippingDestination" @change="getShippingCosts()">
                    <option :value=null>...</option>
                    <option v-for="(listValue, index) in shippingDestinations" :value="listValue.value" :key="index">{{ listValue.title }}</option>
                </select>
                <div v-if="shippingCost">
                    <div class="result" v-if="!shippingCost.isExWorkOnly">{{ localizer.get("Cart.Common.ShippingCostsIntro") }} <span class="cost"><span class="unit">{{ localizer.get("Catalogue.Common.Euro") }}</span>{{ formatPrice(shippingCost.shippingCost) }}</span></div>
                    <div class="result" v-else>
                        {{ localizer.get("App.Common.ShippingExWork") }}
                        <a :href="routes.Support_ShippingReturns + '#ExWorks'" class="link">{{ localizer.get("App.Common.ShippingExWork_More") }}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onBeforeMount } from "vue";
import Axios from "axios";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import Localizer from "@Scripts/Common/Localizer";

const localizer = Localizer;
const routes = (window as any).App.routes;

const shippingDestinations = ref<any[]>([]);
const shippingDestination = ref<string>(null);
const shippingCost = ref<any>(null);
const isActive = ref(false);

onBeforeMount(() => {
    getShippingDestinations();
});

async function getShippingDestinations() {
    let response = (await Axios.post(routes.Cart_GetShippingDestinations)).data;
    
    shippingDestinations.value = response;
}

async function getShippingCosts() {
    if (shippingDestination.value) {
        let response = await Axios.post(routes.Cart_GetShippingCostsByDestination, { shippingDestination: shippingDestination.value });

        shippingCost.value = response.data;

        GTagHelper.sendEvent("click", "delivery_option", shippingDestination.value);
    } else {
        shippingCost.value = null;
    }
}

function formatPrice(data: any) {
    return Number(data).toFixed(2).replace(".", ",");
}

function setExpanding() {
    isActive.value = !isActive.value;
}
</script>
